/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'project-panel.generic-error.description':
    'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'project-panel.generic-error.title': 'Etwas ist schiefgelaufen',
  'project-panel.project-icon-header.update-error-description':
    'Das Symbol von {projectName} konnte nicht aktualisiert werden.',
  'project-panel.project-icon-header.update-error-title': 'Irgendetwas ist schiefgelaufen',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Weitere Felder anzeigen',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Weniger anzeigen',
  'project-panel.project-panel-header.title': 'Projekt',
  'project-panel.project-panel-tabs.about-tab-title': 'Info',
  'project-panel.project-panel-tabs.decisions-title': 'Entscheidungen',
  'project-panel.project-panel-tabs.learnings-title': 'Erkenntnisse',
  'project-panel.project-panel-tabs.risks-title': 'Risiken',
  'project-panel.project-panel-tabs.updates-tab-title': 'Updates',
  'project-panel.project-title.edit-button-label': 'Projekttitel bearbeiten',
  'project-panel.project-title.update-error-description':
    'Der Inhalt von {projectName} konnte nicht aktualisiert werden',
  'project-panel.project-title.update-error-title': 'Etwas ist schiefgelaufen',
  'project-panel.project-title.validation-message': 'Geben Sie bitte einen Titel für Ihr Projekt ein.',
};
